import React, { useEffect } from 'react'
import { useUser } from '@ztechapps/common.hook'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import { appSettings } from '../../../config/app-settings'
import { useHistory } from '@ztechapps/common.hook'
import { routesDef } from '../../../config/routes'

/**
 * This is the initial page the is being load. When still valid login, navigate to the overview page
 * @returns {null}
 */
export default () => {
  const { loggedIn, loading } = useUser()
  const history = useHistory()

  useEffect(() => {
    if (loading) {
      return
    }

    // when the user is not login, the graphql client will automatically redirect to the login page
    // all 401 status will be redirect to  login page so there is no need to put catch here
    // when the user is still has a valid login it will redirect to the overview page
    if (loggedIn) return history.push(routesDef.JoinPage.path)
  }, [loading, loggedIn])

  return (
    <CenterScreen>
      <LoadingContent message={`Loading ${appSettings.AppFullName} app...`} />
    </CenterScreen>
  )
}
